import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { API } from ':api';
import { MYPROFILE_EMPLOYEE_INFO } from ':api/urls';

type UserProfile = {
  first_name: string;
  last_name: string;
  middle_name: string;
};

export const useProfile = (
  employeeNumber: string,
): UseQueryResult<UserProfile | null> =>
  useQuery<UserProfile>({
    queryKey: ['UserProfile', employeeNumber],
    enabled: Boolean(employeeNumber),
    queryFn: async () => {
      const { data } = await API.get(MYPROFILE_EMPLOYEE_INFO(employeeNumber));
      if (data?.results?.[0]) {
        return data.results[0];
      }
      return null;
    },
  });
